import { useEffect, useState } from 'react';
import { useAppLogoUrl } from '@/shared/branding/appLogo';
import { BrandMark } from '../icons';
import styles from './AppLogo.module.css';

/**
 * The lab's logo inside its tile: the picture uploaded in Settings, or the
 * built-in mark when there is none or it cannot be fetched. Request of
 * 6 October 2026.
 *
 * Decorative: the lab's name is always printed beside it.
 */
export function AppLogo({ size }: { size?: number }) {
  const url = useAppLogoUrl();
  const [failed, setFailed] = useState<string | null>(null);

  useEffect(() => {
    setFailed(null);
  }, [url]);

  if (url === null || failed === url) return <BrandMark size={size} />;
  return (
    <img
      className={styles.logo}
      src={url}
      alt=""
      draggable={false}
      onError={() => {
        setFailed(url);
      }}
    />
  );
}
